/**
 * 全局错误处理
 * @description 配置全局错误捕获和处理机制
 */
import type { App } from 'vue'
import { ElMessage } from 'element-plus'

// 设置全局错误处理
export function setupErrorHandler(app: App) {
  // Vue错误处理
  app.config.errorHandler = (err, _instance, info) => {
    console.error('[Vue Error]', err, info)

    // 避免渲染循环错误重复提示，仅对非渲染错误显示用户反馈
    if (info !== 'render function') {
      ElMessage.error({
        message: '页面出现异常，请刷新重试',
        grouping: true, // 防止重复提示
      })
    }
  }

  // 全局警告处理
  app.config.warnHandler = (_msg, _instance, _trace) => {
    // console.warn('Vue Warning:', msg)
    // console.warn('Component Instance:', instance)
    // console.warn('Trace:', trace)
  }
}

// 全局未捕获错误处理
export function setupGlobalErrorHandler() {
  // 捕获未处理的 Promise 错误
  window.addEventListener('unhandledrejection', (event) => {
    // 忽略ResizeObserver相关的Promise错误
    if (event.reason && typeof event.reason === 'string'
      && event.reason.includes('ResizeObserver')) {
      event.preventDefault()
      return
    }

    // 忽略ErrorEvent类型的ResizeObserver错误
    if (event.reason instanceof Error
      && event.reason.message?.includes('ResizeObserver')) {
      event.preventDefault()
      return
    }

    console.error('[Unhandled Promise Rejection]', event.reason)

    // 用户反馈
    ElMessage.error({
      message: '操作异常，请稍后重试',
      grouping: true,
    })

    event.preventDefault()
  })

  // 捕获全局JavaScript错误
  window.addEventListener('error', (event) => {
    // 忽略ResizeObserver循环错误 - 这是一个常见的浏览器兼容性问题
    if (event.message && (
      event.message.includes('ResizeObserver loop limit exceeded')
      || event.message.includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }

    console.error('[Global Error]', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
    })

    // 用户反馈 - 仅对非脚本加载错误显示
    if (event.error) {
      ElMessage.error({
        message: '页面出现异常，请刷新重试',
        grouping: true,
      })
    }
  })

  if (import.meta.env.DEV) {
    console.warn('✅ [错误处理] 全局错误处理器已初始化')
  }
}

export default setupErrorHandler
